export { Card } from './card';
export { cardI18n } from './card.i18n';
